export const HOME = {
    heroCtaPrimary: "hero-cta-primary",
    heroCtaWhatsapp: "hero-cta-whatsapp",
    navHome: "nav-home",
    navServices: "nav-services",
    navPackages: "nav-packages",
    navProcess: "nav-process",
    navFaq: "nav-faq",
    navContact: "nav-contact",
    navCta: "nav-cta",
    emergentLink: "emergent-link",
    logoLink: "logo-link",
};

export const PACKAGES = {
    card: (id) => `package-card-${id}`,
    buyBtn: (id) => `package-buy-${id}`,
};

export const CONTACT = {
    form: "contact-form",
    name: "contact-name",
    email: "contact-email",
    phone: "contact-phone",
    interest: "contact-interest",
    message: "contact-message",
    submit: "contact-submit",
    whatsapp: "contact-whatsapp",
};

export const ADMIN = {
    emailInput: "admin-email",
    passwordInput: "admin-password",
    loginBtn: "admin-login-btn",
    logoutBtn: "admin-logout-btn",
    statsRevenue: "stats-revenue",
    statsLeads: "stats-leads",
    statsNew: "stats-new-leads",
    statsPayments: "stats-payments",
    leadRow: (id) => `lead-row-${id}`,
    leadStatus: (id) => `lead-status-${id}`,
    leadDelete: (id) => `lead-delete-${id}`,
    tabLeads: "tab-leads",
    tabPayments: "tab-payments",
};

export const PAYMENT = {
    successCard: "payment-success-card",
    cancelCard: "payment-cancel-card",
    statusText: "payment-status-text",
    backHome: "payment-back-home",
};
